import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import { flatten } from 'lodash';
import selectors from './selectors';

const options = {
  name: 'incidentResponses',
  baseType: 'INCIDENT_RESPONSES',
  apiEndpoint: 'incidents/{incident_id}/incident_responses'
};

const operations = createMetadataAPIOperations(options);

export { operations, selectors };
const reducer = createMetadataAPIReducer(options);

const augmentedReducer = (state, action) => {
  let result = reducer(state, action);

  switch (action.type) {
    // Responses are embedded in Incidents, and don't have a separate
    // endpoint. When an Incident has been received, take the responses
    // and process them in this IncidentResponse reducer
    case 'FETCH_INCIDENTS_SUCCESS': {
      const responses = flatten(action.payload.data.map(incident => incident.incident_responses));

      for (const response of responses) {
        result = {
          ...result,
          byId: {
            ...result.byId,
            [response.id]: response
          }
        };
      }
      return result;
    }
    default: {
      return result;
    }
  }
};

export default augmentedReducer;
